import Image from '@components/ui/image'
import { useTranslation } from 'next-i18next'

export default function CategoryCardLanding({
  image,
  title,
  description,
  slug,
  subcats,
}) {
  const { t: translate } = useTranslation('common')

  return (
    <div className="bg-white p-6 max-w-md mx-auto rounded-lg flex flex-col space-y-4">
      <a
        href={slug}
        className="text-3xl font-semibold mb-2 text-center text-brand-darkblue cat-card-title"
      >
        {title}
      </a>
      <div className="relative group cat-card-img">
        <Image
          src={image}
          alt={title}
          width={585}
          height={400}
          className="object-contain mx-auto transition-opacity duration-300 group-hover:opacity-60"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <a href={slug} className="w-4/5">
            <button className="cat-card-button w-full font-semibold py-2 px-6 border border-solid border-black shadow-md hover:shadow-lg hover:bg-brand-lightblue transition-all duration-300">
              {translate('text-shop')} {title}
            </button>
          </a>
        </div>
      </div>
      <p className="text-black cat-card-copy">{description}</p>
      <div className="text-lg space-y-2 text-left font-semibold text-brand-darkblue">
        {subcats?.map((link, idx) => (
          <a
            href={link.url_path}
            key={idx}
            className="hover:underline block cat-card-sublinks"
          >
            {link.name}
          </a>
        ))}
      </div>
    </div>
  )
}
